var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaywallBenefitTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.88281 12.4395C10.3877 12.4395 10.6455 12.2461 10.8281 11.709L11.7949 8.98047H16.5967L17.5742 11.709C17.7568 12.2461 18.0146 12.4395 18.5195 12.4395C19.0244 12.4395 19.3574 12.1279 19.3574 11.6445C19.3574 11.4834 19.3252 11.333 19.25 11.1289L15.4473 0.891602C15.2217 0.290039 14.8135 0 14.2012 0C13.5889 0 13.1914 0.290039 12.9766 0.891602L9.16309 11.1396C9.09863 11.3438 9.06641 11.4834 9.06641 11.6553C9.06641 12.1387 9.37793 12.4395 9.88281 12.4395ZM12.2676 7.53027L14.1689 2.1377H14.2227L16.124 7.53027H12.2676Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.794922 12.4287C1.19238 12.4287 1.46094 12.2246 1.60059 11.7627L2.20215 9.9043H5.38184L5.9834 11.7627C6.14453 12.2461 6.41309 12.4287 6.7998 12.4287C7.2832 12.4287 7.60547 12.1279 7.60547 11.6982C7.60547 11.5156 7.55176 11.3223 7.4873 11.1182L5.00586 4.45801C4.78027 3.85645 4.36133 3.54492 3.79199 3.54492C3.2334 3.54492 2.8252 3.83496 2.59961 4.45801L0.107422 11.1182C0.0322266 11.3008 0 11.5049 0 11.6982C0 12.1387 0.311523 12.4287 0.794922 12.4287ZM2.62109 8.66895L3.67383 5.34961H3.91016L4.97363 8.66895H2.62109Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaywallBenefitTextIcon);
export default __webpack_public_path__ + "static/media/paywall_benefit_text_icon.cb8aa6559a29578eac719b427c3ed5e1.svg";
export { ForwardRef as ReactComponent };